(() => {
  if (window.MGFinanceModalReady) return;
  window.MGFinanceModalReady = true;

  let lastTrigger = null;
  let closeTimer = null;

  const getModal = (trigger) => {
    const scope = trigger.closest('#MainContent') || document;
    return scope.querySelector('[data-mg-finance-modal]');
  };

  const closeModal = (modal) => {
    if (!modal || modal.hidden) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('mg-finance-modal-open');
    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(() => {
      modal.hidden = true;
      modal.querySelectorAll('[data-mg-finance-panel]').forEach((panel) => {
        panel.hidden = true;
        panel.classList.remove('is-active');
      });
    }, 180);
    if (lastTrigger) lastTrigger.focus({ preventScroll: true });
  };

  const openModal = (trigger) => {
    const modal = getModal(trigger);
    if (!modal) return;
    const key = trigger.getAttribute('data-mg-finance-open');
    const panel = modal.querySelector('[data-mg-finance-panel="' + key + '"]');
    if (!panel) return;

    window.clearTimeout(closeTimer);
    modal.querySelectorAll('[data-mg-finance-panel]').forEach((item) => {
      const active = item === panel;
      item.hidden = !active;
      item.classList.toggle('is-active', active);
    });

    const dialog = modal.querySelector('[role="dialog"]');
    const title = panel.querySelector('h2');
    if (title) dialog.setAttribute('aria-labelledby', title.id);

    lastTrigger = trigger;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('mg-finance-modal-open');
    requestAnimationFrame(() => {
      modal.classList.add('is-open');
      modal.querySelector('[data-mg-finance-close]:not(.mg-finance-modal__backdrop)')?.focus({ preventScroll: true });
    });
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-mg-finance-open]');
    if (trigger) {
      event.preventDefault();
      openModal(trigger);
      return;
    }
    const closer = event.target.closest('[data-mg-finance-close]');
    if (closer) {
      event.preventDefault();
      closeModal(closer.closest('[data-mg-finance-modal]'));
    }
  });

  document.addEventListener('keydown', (event) => {
    const modal = document.querySelector('[data-mg-finance-modal].is-open');
    if (!modal) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal(modal);
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = [...modal.querySelectorAll('button:not([disabled]), a[href]')].filter((item) => !item.hidden);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();
